import { render, staticRenderFns } from "./PlatformEntriesView.vue?vue&type=template&id=68a85cee&scoped=true"
import script from "./PlatformEntriesView.vue?vue&type=script&lang=js"
export * from "./PlatformEntriesView.vue?vue&type=script&lang=js"
import style0 from "./PlatformEntriesView.vue?vue&type=style&index=0&id=68a85cee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a85cee",
  null
  
)

export default component.exports